const renderBanner = (d, buttonConfig, buttonContainer, setFixed = false) => {
	const buttonId = buttonConfig[0],
		mainText = buttonConfig[1],
		buttonText = buttonConfig[2],
		position = buttonConfig[3],
		horizontal = buttonConfig[4],
		vertical = buttonConfig[5],
		container = d.createElement('div'),
		closeLink = d.createElement('a'),
		closeImage = d.createElement('img'),
		text = d.createElement('div'),
		button = d.createElement('a'),
		copyright = d.createElement('div');

	container.className = 'floatingbanner';
	container.style.bottom = `${vertical}px`;

	container.style.right = 'auto';
	container.style.left = `${horizontal}px`;
	if (position === 'right') {
		container.style.left = 'auto';
		container.style.right = `${horizontal}px`;
		container.style.borderBottomRightRadius = 0;
		container.style.borderBottomLeftRadius = '20px';
	}
	if (setFixed) {
		container.style.position = 'fixed';
	}
	container.append(closeLink);
	closeLink.href = '#';
	closeLink.className = 'link-block-4 w-inline-block';
	closeLink.addEventListener(
		'click',
		(e) => (e.currentTarget.closest('div').style.display = 'none')
	);
	closeLink.append(closeImage);
	closeImage.src =
		'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTMuNDM1MSIgeT0iNC4yNDI2OCIgd2lkdGg9IjEiIGhlaWdodD0iMTMiIHRyYW5zZm9ybT0icm90YXRlKDQ1IDEzLjQzNTEgNC4yNDI2OCkiIGZpbGw9IiNDNEM0QzQiLz4KPHJlY3QgeD0iMTQuMTQyMSIgeT0iMTMuNDM1MSIgd2lkdGg9IjEiIGhlaWdodD0iMTMiIHRyYW5zZm9ybT0icm90YXRlKDEzNSAxNC4xNDIxIDEzLjQzNTEpIiBmaWxsPSIjQzRDNEM0Ii8+Cjwvc3ZnPgo=';
	closeImage.loading = 'lazy';
	closeImage.alt = '';
	container.append(text);
	text.className = 'text-block-floating';
	text.innerHTML = mainText;
	container.append(button);
	button.dataset.eyezonPutInCart = 'true';
	if (window.hasOwnProperty('eyeZonTargetId')) {
		button.dataset.eyezonTarget = window.eyeZonTargetId;
	}
	button.dataset.eyezon = buttonId;
	button.href = '#';
	button.className = 'button-7 w-button';
	button.innerHTML = buttonText;
	container.append(copyright);
	copyright.className = 'text-block-11';
	copyright.innerHTML = 'Powered by eyezon.live';
	buttonContainer.append(container);
};

const initScript = (businessId) => {
	(function (w, d, s, o, f, js, fjs) {
		w[o] =
			w[o] ||
			function () {
				(w[o].q = w[o].q || []).push(arguments);
			};
		js = d.createElement(s);
		fjs = d.getElementsByTagName(s)[0];
		js.id = o;
		js.src = f;
		js.async = true;
		fjs.parentNode.insertBefore(js, fjs);
	})(
		window,
		document,
		'script',
		'eyeZon',
		'https://storage.googleapis.com/eyezonscriptv2/static/js/eyezonwidget.js'
	);

	eyeZon('init', { businessId, region: 'ru-1' });

	if (
		window.hasOwnProperty('EYEZON_DATA') &&
		window.EYEZON_DATA.isWooCommerceLoaded
	) {
		eyeZon('on', 'PUT_IN_CART_FROM_WIDGET', eyezonPutInCart);
		eyeZon('on', 'STREAMER_PUT_IN_CART_ACCEPTED', eyezonPutInCart);

		jQuery(document.body).on(
			'added_to_cart',
			(e, fragments, cartHash, button) => {
				eyeZon('emit', 'PUT_IN_CART', [button.data('product_sku')]);
			}
		);
	}

	window.eyeZonRender = true;
};

const eyezonPutInCart = (data) => {
	if (
		window.hasOwnProperty('EYEZON_DATA') &&
		window.EYEZON_DATA.isWooCommerceLoaded
	) {
		const postData = new FormData();
		postData.set('action', 'eyeZonAjaxAddToCart');
		postData.set('target', data.target);
		if (data.hasOwnProperty('barcode') && data.barcode) {
			postData.set('barcode', data.barcode);
		}
		fetch(window.EYEZON_DATA.ajax_url, { method: 'POST', body: postData })
			.then((r) => r.json())
			.then((r) => {
				if (r.success) {
					eyeZon('emit', 'PUT_IN_CART', [r.sku]);
					jQuery(document.body).trigger('wc_fragment_refresh');
				} else {
					console.log(r);
				}
			});
	}
};

export { renderBanner, initScript, eyezonPutInCart };
